<template>
  <BasicSkeleton :show-placeholder="pending">
    <NuxtImg
      v-if="mediumData"
      provider="cloudflare"
      :src="mediumData.originalData"
      :title="title"
      :alt="altText"
      :preset="preset"
    />
    <template #placeholder>
      <div>AAAAAAAAAAAAAH</div>
    </template>
  </BasicSkeleton>
</template>

<script setup lang="ts">
import { getMedium } from '~/composables/ExpApi/expCache';

interface Props {
  mediumId: string;
  title?: string;
  preset?: string;
  draggable?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  preset: '',
  draggable: true,
});

const { data: mediumData, pending } = await getMedium(props.mediumId);

const title = computed(() => {
  return props.title || mediumData.value?.title || mediumData.value?.alt || mediumData.value?.name;
});
const altText = computed(() => {
  return mediumData.value?.alt || mediumData.value?.title || mediumData.value?.name || props.title;
});
</script>

<style scoped lang="postcss"></style>
